import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

//window.subdominio = "davidperedoarquitecto";
//window.rutasubdominio = "davidperedoarquitecto.greencardpv.com";

window.subdominio = window.location.host.split('.')[0];
window.rutasubdominio = window.location.host;

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
